export default {
  headerTile: 'Todo lo que necesita saber sobre su viaje',
  contact: 'Contacto',
  noContacts: 'No hay contactos',
  tourResume: 'Resumen del viaje',
  extraField: 'Extras',
  day: 'Día',
  tour: 'Tour',
  flight: 'Vuelo',
  transfer: 'Traslado',
  transportLuggage: 'Transporte de su equipaje',
  stageNumOriginDestination: 'Etapa: { origin } - { destination }',
  distanceNumberKm: 'Distancia: { number } Km',
  notSelectTransfer: 'Aún no ha seleccionado un traslado',
  notSelectTransport: 'Aún no has seleccionado un transporte',
  accommodation: 'Alojamiento',
  information: 'Información',
  quantityNights: 'Ninguna noche | Una noche | { quantity } noches',
  totalPrice: 'Precio total',
  whatToDoLocation: 'Qué hacer en { location }',
  urlToLocationMap: 'Url al mapa de { location }',
  urlToLocationWeb: 'Url to { location } website',
  website: 'Sitio web',
  map: 'Mapa',
  linkAboutDay: 'Enlace sobre el día',
  guidebookLocation: 'Guía: { location }',
  viewWebsite: 'Ver sitio web',
  viewGoogleMaps: 'Ver en Google Maps',
  stageInformation: 'Información de la etapa',
  dayInformation: 'Información del día',
  guidebookOfLocation: 'Guía de { location }',
  linkGoogleMapsResource: 'Enlace a Google Maps de { resource }',
  linkResourceWebsite: 'Enlace al sitio web de { resource }',
  address: 'Dirección',
  noResourcesLocation: 'No se han añadido recursos a esta ubicación',
  viewWebsiteOfSupplier: 'Ver el sitio web de { supplier }',
  urlGoogleMapsOfSupplier: 'Url a Google Maps de { supplier }',
  travelInformation: 'Información de tu viaje',
  pricePerPerson: 'Precio por persona',
  downloadErrorText: 'Ha ocurrido un error al descargar',
  pricePerUnit: '€/unidad',
  printTravelBook: 'Imprimir Libro de Viaje',
  preparedFor: 'Preparado Para',
  reference: 'Referencia',
  beforeTrip: 'Antes de Su Viaje',
  afterTrip: 'Información Post Viaje',
  supportContacts: 'Soporte y Contactos',
  inclusionsExclusions: 'Qué Incluye y Qué No',
  whatsIncluded: 'Qué Incluye',
  whatsNotIncluded: 'Qué No Incluye',
  optionalExtras: 'Extras Opcionales',
  readyToAdventure: '¿Listo para la Aventura?',
  finalizeReservation: 'Finalice su reserva y asegure su itinerario personalizado hoy.',
  whatsappSpecialist: 'Especialista por WhatsApp',
  requestReservation: 'Solicitar Reserva',
  itineraryNotFound: 'Itinerario No Encontrado',
  itineraryNotFoundDescription: 'No pudimos recuperar este itinerario. Puede haber expirado o el enlace no es válido.',
  returnHome: 'Volver al Inicio',
  featuredImage: 'Imagen Destacada del Viaje',
  km: 'km',
  service: 'Servicio',
  services: 'Servicios',
  viewMore: 'Ver Más',
  viewLess: 'Ver Menos',
  hotel: 'Alojamiento',
  activity: 'Actividad',
  transport: 'Transporte',
  general_information: 'Información General',
  stage_information: 'Información de la Etapa',
};
